export const fees = {
    EUR: 2.0,
    AUD: 4.0,
    BGN: 4.0,
    BIF: 7000.0,
    BSD: 2.0,
    CAD: 3.0,
    CHF: 2.0,
    CLP: 2500.0,
    COP: 1000.0,
    CRC: 1000.0,
    CZK: 50.0,
    DJF: 500.0,
    DKK: 20.0,
    GBP: 2.0,
    GNF: 20000.0,
    HKD: 20.0,
    HUF: 20000.0,
    IDR: 40000.0,
    ISK: 300.0,
    JPY: 500.0,
    KMF: 1000.0,
    KRW: 5000.0,
    MGA: 10000.0,
    MXN: 50.0,
    MYR: 250.0,
    NOK: 25.0,
    NZD: 5.0,
    PEN: 10.0,
    PHP: 150.0,
    PLN: 10.0,
    PYG: 20000.0,
    RON: 10.0,
    RWF: 5000.0,
    SEK: 20.0,
    SGD: 3.0,
    THB: 100.0,
    TWD: 100.0,
    UGX: 10000.0,
    USD: 2.0,
    UZS: 30000.0,
    VND: 75000.0,
    VUV: 300.0,
    XAF: 1500.0,
    XOF: 1500.0,
    XPF: 300.0,
    ZAR: 50.0
};
